import { useEffect } from "react";

const DEFAULT_DESC =
  "Free resale price estimate for used phones, laptops and electronics in India. Clear price breakdown, no login needed. Valuelix does not buy devices.";

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key] = selector.match(/\[(?:name|property)="(.+)"\]/) || [];
    if (selector.includes("property=")) el.setAttribute("property", key);
    else el.setAttribute("name", key);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

// Lightweight per-page SEO: updates <title> and description/OG/Twitter meta.
const ORIGIN = "https://valuelix.com";

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

// Canonical URL: path only, except the category on /valuate (each category is its own page).
function canonicalUrl() {
  const { pathname, search } = window.location;
  const cat = pathname === "/valuate" ? new URLSearchParams(search).get("category") : null;
  return ORIGIN + (pathname === "/for-dealers" ? "/dealers" : pathname) + (cat ? `?category=${encodeURIComponent(cat)}` : "");
}

export function useSeo(title, description = DEFAULT_DESC, opts = {}) {
  const noindex = !!opts.noindex;
  useEffect(() => {
    const url = canonicalUrl();
    setCanonical(url);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow");
    if (title) document.title = title;
    setMeta('meta[name="description"]', "content", description || DEFAULT_DESC);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
  }, [title, description, noindex]);
}

export const SEO_DEFAULT_DESCRIPTION = DEFAULT_DESC;
